import { CommonModule } from '@angular/common';
import {
	Inject,
	InjectionToken,
	ModuleWithProviders,
	NgModule,
	Optional,
	Provider,
} from '@angular/core';
import { LocDefs } from './models';
import { MapLocKeys } from './models/map-loc-keys.fn';
import { LocalizationService } from './services/localization.service';

export const LOC_INJECTOR = new InjectionToken<Record<string, string>>('Load Localizations');

export const LocalizationProvider = (locs: LocDefs, ignorePortal = false): Provider => ({
	provide: LOC_INJECTOR,
	useFactory: LocalizationLoadFactory(locs, ignorePortal),
	deps: [LocalizationService],
});

const LocalizationLoadFactory = (
	localizations: LocDefs,
	ignorePortal = false
): ((service: LocalizationService) => void) => {
	return service => {
		service.load(localizations, ignorePortal);
		return { ...MapLocKeys(localizations) };
	};
};

@NgModule({
	imports: [CommonModule],
})
export class LocalizationModule {
	constructor(@Inject(LOC_INJECTOR) @Optional() private readonly loader: any) {}
	static forRoot(): ModuleWithProviders<LocalizationModule> {
		return {
			ngModule: LocalizationModule,
			providers: [],
		};
	}

	static forChild(locs: LocDefs, ignorePortal = false): ModuleWithProviders<LocalizationModule> {
		return {
			ngModule: LocalizationModule,
			providers: [
				{
					provide: LOC_INJECTOR,
					useFactory: LocalizationLoadFactory(locs, ignorePortal),
					multi: true,
					deps: [LocalizationService],
				},
			],
		};
	}
}
